import { Identifiable } from "../../../shared/models/identifiable.model";
import { Horaire } from "../../horaires/models/horaires.model";
import { JustupOffre } from "../justup-offre.enum";

export interface ActivityInfos extends Identifiable {
  denomination: string;
  siret: string;
  fj: string;
  docId: string;
  capital: string;
  rcsVille: string;
  rcsNumero: string;
  codeAPE: string;
  tvaIntracom: string;
  email: string;
  emailFacture: string;
  telephone: string;
  groupId: string;
  codeGS1: string;
  textColor: boolean;
  color: string;
  devise: string;
  infoCommandeFournisseur: string;
  infoFactureExpedition: string;
  infoAvoirClient: string;
  infoConfirmationCommandeClient: string;
  localIps: string;
  authorizedIps: string;
  horaires: Horaire[];
  offre: JustupOffre;
  validationSpecif: ValidationSpecif;
  validationOF: ValidationOF;
  consigneNC: string;
  promptAIProcess: string;
  dateDebutExercice: string;
  signatureOperateurObligatoire: boolean;

  /**
   * Délai logistique par défaut pour les expéditions client, en jours ouvrés
   * (P0a — mai 2026). Fallback si l'adresse de livraison n'a pas de
   * `delaiExpeditionJoursOuvres`. Si null, l'expé = livraison.
   */
  delaiExpeditionParDefautJoursOuvres?: number;

  /**
   * R5 refonte DDM/DLC — feature flag de blocage strict des expéditions
   * contenant un stock avec DLC dépassée. Default `false` pour rétro-compat.
   * À activer chez les clients agro frais et IFS-compliants après
   * reclassification de leurs articles en DDM/DLC.
   * Cf. `docs/plans/roadmap-ddm-prepa.md` phase R5.
   */
  activerBlocageDLC?: boolean;
}

export enum ValidationSpecif {
  VALIDATION = "VALIDATION",
  NONE = "NONE",
}

export enum ValidationOF {
  SIMPLE = "SIMPLE",
  DOUBLE = "DOUBLE",
  NONE = "AUTO",
}

export enum ValidationFacture {
  NUMEROTATION_AUTO = "NUMEROTATION_AUTO",
  CREATION_SANS_NUMEROTATION = "CREATION_SANS_NUMEROTATION",
  NONE = "NONE",
}

